//Fishbones.jsx (Fishbones List)
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { useNavigate, useParams } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
import MainLayout from '../../layouts/MainLayout';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faFishFins, faPlus } from '@fortawesome/free-solid-svg-icons';
import { useLocation } from 'react-router-dom';
import Loader from '../../components/utils/Loader';
import Tooltip from '../../components/utils/Tooltip';
import FishboneInfoGraphics from './FishboneInfoGraphics';
import FishboneInfographics1Image from '../../fivewhystemplates/FishboneInfographics1.png';
import './SwimmingFish.css';

const Fishbones = () => {
  const location = useLocation();
  const authState = useSelector(state => state.authReducer);
  const navigate = useNavigate();

  const [userId, setUserId] = useState(authState.user._id);
  
  const [fishbones, setFishbones] = useState([]);
  const [fetchData, { loading }] = useFetch();
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [tags, setTags] = useState('');
  const [selectedFishboneId, setSelectedFishboneId] = useState(null);

const fetchFishbones = useCallback((fishboneType) => {
  const config = {
      url: "/fishbone/my",
      method: "post",
      headers: { Authorization: authState.token },
      data: { userId: userId }
  };
  
  fetchData(config, { showSuccessToast: false })
      .then(response => {
          // console.log("Response:", response);
          if (response && Array.isArray(response.fishbones)) {
              setFishbones(response.fishbones);
          } else {
              console.error("Invalid response format: fishbone not found in response");
          }
      })
      .catch(error => {
          console.error("Error fetching fishbones:", error);
      });
}, [authState.token, fetchData]);

 useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchFishbones();
  }, [authState.isLoggedIn, fetchFishbones]);

  // useEffect(() => {
  //   if (fishboneType) {
  //     fetchFishbones(fishboneType);
  //   }
  // }, [fishboneType, fetchFishbones]);

  const [isDeleteClicked, setIsDeleteClicked] = useState(false);
    const deleteClicked = () => {
      setIsDeleteClicked(true);
    }
    
    const noDeleteClicked = () => {
      setIsDeleteClicked(false);
    }

  const handleDelete = (id) => {
    const config = { url: `/fishbone/${id}`, method: "delete", headers: { Authorization: authState.token } };
    fetchData(config).then(() => {
      setFishbones(fishbones.filter(fishbone => fishbone._id !== id));
    }).catch(error => {
      console.error('Failed to delete the record:', error);
    });
  }

  const handleView = (fishboneId) => {
    setSelectedFishboneId(prevId => (prevId === fishboneId ? null : fishboneId));
  };

  const handleCloseFishboneDetails = () => {
    setSelectedFishboneId(null);
  };

  const handleFromDateChange = (date) => {
    setFromDate(date);
  };

  const handleToDateChange = (date) => {
    setToDate(date);
  };

  const handleSearch = () => {
    // Implement search functionality
  };

  const handleFishboneClick = (fishboneId) => {
    setSelectedFishboneId(fishboneId);
  };

  const handleFishboneShare = (fishboneId) => {
    setSelectedFishboneId(fishboneId);
  };

  const handleFishboneSave = (fishboneId) => {
    setSelectedFishboneId(fishboneId);
  };

  const handleFishbonePrint = (fishboneId) => {
    setSelectedFishboneId(fishboneId);
  };

  const formatDate = (date) => {
    const jsDate = new Date(date);
    const day = jsDate.getDate().toString().padStart(2, '0');
    const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
    const year = jsDate.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const formatDateTime = (date) => {
    const options = {
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit',
        hour12: false
    };
    const jsDate = new Date(date);
    const day = jsDate.getDate().toString().padStart(2, '0');
    const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
    const year = jsDate.getFullYear();
    const hours = jsDate.getHours().toString().padStart(2, '0');
    const minutes = jsDate.getMinutes().toString().padStart(2, '0');
    const seconds = jsDate.getSeconds().toString().padStart(2, '0');
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
};

  const sortedFishbones = [...fishbones].sort((a, b) => new Date(b.dateCreated) - new Date(a.dateCreated));

  const [fishbone1, setFishbone1]=useState(false);
  const handleFishbone1 = () => {
    setFishbone1(prevState => !prevState);
  };

  const handleAddNew = () => {
    navigate("/fishbone/add");
  };

  return (
    <div className='bg-black'>
        <div className='py-4 px-2 border-b border-blue-400'>
           <h2 className='text-xl lg:text-2xl font-bold text-yellow-200 text-start mb-2'>Fishbone List</h2>
        </div>
        <div className="min-h-[80vh] my-2 mx-auto py-4">
          <div className="p-4 mt-4">
              <div className="mt-2">
                {fishbones && fishbones.length !== 0 && (
                  <div className="flex justify-between items-center border-b border-b-gray-300">
                    <div>
                      <h3 className='text-xl mt-1 mx-2 text-white'>{fishbones.length} Fishbones Found!</h3>
                    </div>
                    <div className='flex w-40'>
                      <Link to='/fishbone/add' className='w-20 px-1 py-2 ml-4 bg-blue-500'>
                        <FontAwesomeIcon className="bg-blue-500 mr-4" icon={faPlus} />  Add New
                      </Link>
                    </div>
                  </div>
                )}
              </div>
          {loading ? (
            <Loader />
          ) : (
            <div>
              {fishbones && fishbones.length === 0 ? (
                <div className='flex flex-col items-center justify-center h-full'>
                  <h3 className='text-xl mb-2 mt-1 mx-2 text-yellow-200'>No Record Found!</h3>
                  <button className="small-button w-40" onClick={handleAddNew}>+ Add New</button>
                </div>
              ) : (
                sortedFishbones.map((fishbone, index) => (
                  <div key={fishbone._id} className='bg-white my-4 p-4 text-gray-600 rounded-md shadow-md'>
                    <div className='flex'>
                      <span className='font-medium'>#{index + 1} ({formatDateTime(fishbone.dateCreated)})</span>
                      <Tooltip text={"View details"} position={"top"}>
                        <span className='ml-auto mr-4 text-blue-500 cursor-pointer' onClick={() => handleView(fishbone._id)}>
                          <i className="fa-solid fa-eye"></i>
                        </span>
                      </Tooltip>
                      <Tooltip text={"Edit this record"} position={"top"}>
                        <Link to={`/fishbone/${fishbone._id}`} className='mr-4 text-green-600 cursor-pointer'>
                          <i className="fa-solid fa-pen"></i>
                        </Link>
                      </Tooltip>
                      <Tooltip text={"Delete this record"} position={"top"}>
                          <span className='text-red-500 cursor-pointer mr-2' onClick={() => deleteClicked()}>
                            <i className="fa-solid fa-trash"></i>
                          </span>
                      </Tooltip>
                      { isDeleteClicked && (
                        <div>
                          <div
                            className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center"
                            style={{ zIndex: 1000 }}
                          >
                            <div className="w-6/12 flex flex-row justify-center bg-blue-200 text-black border-b border-b-gray-300 mr-4 ml-4 p-4">
                                <button
                                  className="bg-red-700 w-40"
                                  onClick={() =>  handleDelete(fishbone._id) }
                                  style={{ maxWidth: "150px" }}
                                >
                                  Confirm To Delete
                                </button>
                                <button
                                  className="bg-yellow-300 ml-4 text-black w-40"
                                  onClick={() =>  noDeleteClicked() }
                                  style={{ maxWidth: "150px" }}
                                >
                                  No I Do Not Want To Delete
                                </button>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className='whitespace-pre  text-blue-700'>{fishbone.problemTitle}</div>
                    {selectedFishboneId === fishbone._id && (
                      <div className='bg-gray-200 text-black'>
                        <h2 className='text-blue-600'><strong>Fishbone</strong></h2>
                        <p>
                          <strong>Problem Category: </strong>  
                          {fishbone.category === ''? "Undefined": fishbone.category} 
                        </p>
                        <p><strong>Problem Statement:</strong> {fishbone.problemTitle}</p>
                        <p><strong>Date Created:</strong> {formatDateTime(fishbone.dateCreated)}</p>
                        <div className='ml-4 mt-4 mb-4'>
                          <Tooltip text={"fishbone1"} position={"top"}>
                          <div className="swimming-fish-container">
                              <div className="fish-icon text-red-500 cursor-pointer text-2xl"onClick={() => handleFishbone1(fishbone._id, 1)}>
                                <FontAwesomeIcon icon={faFishFins} />
                            </div>
                            <div className="wave"></div>
                          </div>
                          </Tooltip>
                          {fishbone1 && (
                            <FishboneInfoGraphics
                                title={fishbone.problemTitle}
                                problem={fishbone.problem.short}
                                cat1={fishbone.cat1?.name || ''}
                                cat2={fishbone.cat2?.name || ''}
                                cat3={fishbone.cat3?.name || ''}
                                cat4={fishbone.cat4?.name || ''}
                                cat5={fishbone.cat5?.name || ''}
                                cat6={fishbone.cat6?.name || ''}
                                cat1cause1={fishbone.cat1?.causes[0]?.name || ''}
                                cat1cause2={fishbone.cat1?.causes[1]?.name || ''}
                                cat2cause1={fishbone.cat2?.causes[0]?.name || ''}
                                cat2cause2={fishbone.cat2?.causes[1]?.name || ''}
                                cat3cause1={fishbone.cat3?.causes[0]?.name || ''}
                                cat3cause2={fishbone.cat3?.causes[1]?.name || ''}
                                cat4cause1={fishbone.cat4?.causes[0]?.name || ''}
                                cat4cause2={fishbone.cat4?.causes[1]?.name || ''}
                                cat5cause1={fishbone.cat5?.causes[0]?.name || ''}
                                cat5cause2={fishbone.cat5?.causes[1]?.name || ''}
                                cat6cause1={fishbone.cat6?.causes[0]?.name || ''}
                                cat6cause2={fishbone.cat6?.causes[1]?.name || ''}
                                fontSize={11}
                                lineHeight={15}
                                maxWidth={25}
                                
                                startXProblem={300}
                                startYProblem={100}

                                startXTitle={515}
                                startYTitle={290}

                                startXCat1={90}
                                startYCat1={180}
                                startXCat2={200}
                                startYCat2={180}
                                startXCat3={300}
                                startYCat3={180}
                                startXCat4={90}
                                startYCat4={410}
                                startXCat5={200}
                                startYCat5={410}
                                startXCat6={300}
                                startYCat6={410}
                                
                                startXCat1Cause1={150}
                                startYCat1Cause1={260}
                                startXCat2Cause1={250}
                                startYCat2Cause1={260}
                                startXCat3Cause1={350}
                                startYCat3Cause1={260}

                                startXCat1Cause2={200}
                                startYCat1Cause2={200}
                                startXCat2Cause2={300}
                                startYCat2Cause2={200}
                                startXCat3Cause2={400}
                                startYCat3Cause2={200}

                                startXCat4Cause1={200}
                                startYCat4Cause1={350}
                                startXCat5Cause1={300}
                                startYCat5Cause1={370}
                                startXCat6Cause1={410}
                                startYCat6Cause1={370}

                                startXCat4Cause2={150}
                                startYCat4Cause2={310}
                                startXCat5Cause2={250}
                                startYCat5Cause2={310}
                                startXCat6Cause2={350}
                                startYCat6Cause2={310}
                                imageSrc={FishboneInfographics1Image}
                                viewWidth={800}
                            />
                          )}
                        </div>
                        <div className='mt-4'>
                          <h3 className='text-lg font-bold text-blue-500'>Problem Details</h3>
                          <p><strong>Short Description:</strong> {fishbone.problem.short}</p>
                          <p><strong>Description:</strong> {fishbone.problem.description}</p>
                          <p><strong>Remarks:</strong> {fishbone.problem.remarks}</p>
                        </div>

                        {[fishbone.cat1, fishbone.cat2, fishbone.cat3, fishbone.cat4, fishbone.cat5, fishbone.cat6].map((category, index) => (
                          category && (
                            <div key={index} className='mt-4'>
                              <h3 className='text-lg font-bold text-purple-500'>
                                {index+1}. {category.name} (Short Name: {category.shortcode === '' ? "NA": category.shortcode})
                              </h3>
                              {category.causes.map((cause, causeIndex) => (
                                <div key={causeIndex} className='ml-4 mt-2'>
                                  <h4 className='text-md font-semibold text-teal-500'>
                                    {causeIndex+1}. {cause.name} 
                                    (Short Name: {cause.shortcode === '' ? "NA" : cause.shortcode})
                                  </h4>
                                  <p><strong>Details:</strong> {cause.details}</p>
                                  <p><strong>Count:</strong> {cause.count}</p>
                                  <p><strong>Weightage:</strong> {cause.weightage}</p>
                                  <p><strong>Solution:</strong> {cause.solution}</p>
                                  <p><strong>Why Code:</strong> {cause.whyCode}</p>
                                  <p><strong>Remarks:</strong> {cause.remarks}</p>

                                  {cause.subcauses.length > 0 && (
                                    <div className='ml-4 mt-2'>
                                      <h5 className='text-sm font-semibold'>Subcauses:</h5>
                                      {cause.subcauses.map((subcause, subcauseIndex) => (
                                        <div key={subcauseIndex} className='ml-2 mt-1'>
                                          <h6 className='text-sm font-medium text-orange-400'>{subcauseIndex+1}. {subcause.name} (Shortcode: {subcause.shortcode})</h6>
                                          <p><strong>Details:</strong> {subcause.details}</p>
                                          <p><strong>Count:</strong> {subcause.count}</p>
                                          <p><strong>Weightage:</strong> {subcause.weightage}</p>
                                          <p><strong>Solution:</strong> {subcause.solution}</p>
                                          <p><strong>Why Code:</strong> {subcause.whyCode}</p>
                                          <p><strong>Remarks:</strong> {subcause.remarks}</p>
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                </div>
                              ))}
                            </div>
                          )
                        ))}
                        
                        <Tooltip text={"Share"} position={"top"}>
                          <span className='text-green-500 cursor-pointer mr-4' disabled={true} onClick={() => handleFishboneShare(fishbone._id)}>
                            <i className="fa-solid fa-share"></i>
                          </span>
                        </Tooltip>
                        <Tooltip text={"Save"} position={"top"}>
                          <span className='text-blue-500 cursor-pointer mr-4' disabled={true} onClick={() => handleFishboneSave(fishbone._id)}>
                            <i className="fa-solid fa-save"></i>
                          </span>
                        </Tooltip>
                        <Tooltip text={"Print"} position={"top"}>
                          <span className='text-orange-500 cursor-pointer mr-4' disabled={true} onClick={() => handleFishbonePrint(fishbone._id)}>
                            <i className="fa-solid fa-print"></i>
                          </span>
                        </Tooltip>
                      </div>
                    )}
                  </div>
                ))
              )}
            </div>
          )}
        </div>      
      </div>
      <footer className="bg-gray-900 border-t border-blue-400 text-gray-400 py-4">
        <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-sm">© 2025 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="hover:text-teal-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
          </div>
        </div>
      </footer>          
    </div>
  )
}

export default Fishbones;
